export default __webpack_public_path__ + "static/media/header-background.f7191779.jpg";